import React from "react";

export const ModalScreen = ({ children, close, upload = null }) => {
  const onClose = ({ target }) => {
    if (target.id === "modal-screen-center") {
      close(false);
      if (upload !== null) upload();
    }
  };
  return (
    <div id="modal-screen-center" onClick={(e) => onClose(e)}>
      {children}
    </div>
  );
};








